<template>
  <div
    class="ren-decoration-cp ren-decoration-cp-banner"
    :class="{ 'is-empty': !imageUrl }"
    :style="bannerStyle">
    <img v-if="imageUrl" :src="imageUrl" :alt="title || '轮播图'" />
    <div v-if="showCopy" class="ren-decoration-cp-banner__copy">
      <em v-if="eyebrow">{{ eyebrow }}</em>
      <strong v-if="title">{{ title }}</strong>
      <div v-if="subtitle || buttonText">
        <span v-if="subtitle">{{ subtitle }}</span>
        <button v-if="buttonText" type="button">{{ buttonText }}</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import {
  numberValue,
  previewBoundString,
  previewRecordsFor,
  recordList,
  stringValue
} from '../../../previews/preview-helpers'
import { widgetMediaUrl } from '../../media'
import type { WidgetPreviewProps } from '../../types'
import { WIDGET_STYLE_FALLBACKS } from '../../widget-style-defaults'

const props = defineProps<WidgetPreviewProps>()

const items = computed(() => {
  const fallback = recordList(props.component.props?.items)
  return previewRecordsFor(props.component, props.componentData, fallback)
})

const firstItem = computed(() => items.value[0] ?? {})

const imageUrl = computed(() =>
  widgetMediaUrl(
    previewBoundString(
      props.component,
      props.componentData,
      'item.imageUrl',
      stringValue(firstItem.value.imageUrl ?? firstItem.value.image),
      firstItem.value
    )
  )
)

const title = computed(() =>
  previewBoundString(
    props.component,
    props.componentData,
    'item.title',
    stringValue(firstItem.value.title ?? firstItem.value.label),
    firstItem.value
  ).trim()
)

const subtitle = computed(() =>
  previewBoundString(
    props.component,
    props.componentData,
    'item.subtitle',
    stringValue(firstItem.value.subtitle ?? props.component.props?.subtitle),
    firstItem.value
  ).trim()
)

const eyebrow = computed(() => stringValue(props.component.props?.eyebrow))
const buttonText = computed(() => stringValue(props.component.props?.buttonText))
const showCopy = computed(
  () => Boolean(eyebrow.value || title.value || subtitle.value || buttonText.value)
)
const bannerStyle = computed(() => {
  if (imageUrl.value) return undefined
  const primary = props.themeTokens?.primaryColor || props.themeColor || 'var(--ren-theme-primary)'
  const accent = props.themeTokens?.accentColor || primary
  return {
    minHeight: `${Math.max(88, numberValue(props.component.style?.height, WIDGET_STYLE_FALLBACKS.mediaHeight))}px`,
    background: `linear-gradient(135deg, ${primary}, ${accent})`
  }
})
</script>
